const faqItems = [
  {
    q: '7788电影网真的完全免费吗？',
    a: '是的，7788电影网所有电影资源均免费提供在线观看。我们通过广告合作维持运营，但严格控制在不会干扰观影体验的范围内，绝不设置强制广告或付费墙，你可以放心畅享电影大全中的所有内容。',
  },
  {
    q: '观看电影需要注册账号吗？',
    a: '不需要。7788电影网倡导无障碍观影理念，所有最新电影和热门电影均可直接在线观看，无需任何注册或登录步骤，点开即看，方便快捷。',
  },
  {
    q: '电影画质怎么样？支持哪些清晰度？',
    a: '本站全线影片最低提供720P高清画质，主流影片均支持1080P全高清播放，部分热门大片更提供4K超清选项。我们采用智能码率自适应技术，根据你的网络状况自动匹配最佳清晰度，确保高清播放不缓冲。',
  },
  {
    q: '电影排行榜是如何生成的？',
    a: '电影排行榜基于真实用户播放热度、停留时长、重复观看率和用户评分的综合算法实时生成，每小时自动更新一次。你可以通过排行榜快速了解当前最受欢迎的热门电影，发现大家都在看什么。',
  },
  {
    q: '手机端可以观看吗？体验如何？',
    a: '当然可以！7788电影网全面适配手机、平板等移动端设备，支持iOS和Android系统。移动端同样享受高清流畅的播放体验，而且界面专门针对触屏操作优化，随时随地都能畅快观影。',
  },
];

import { useState } from 'react';

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            常见问题
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            关于7788电影网的常见疑问与解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-100 overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-200 transition-colors"
              >
                <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <i
                  className={`text-lg text-foreground-500 flex-shrink-0 transition-transform duration-300 ${
                    openIdx === idx ? 'ri-subtract-line rotate-180' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              {openIdx === idx && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}